import React from 'react';

interface DeleteConfirmationModalProps {
  problem: { question: string; answer: string };
  onClose: () => void;
  onConfirm: (answer: string) => void;
}

export const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  problem,
  onClose,
  onConfirm,
}) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg max-w-md w-full p-6">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Verify Deletion</h3>
        <p className="text-gray-600 mb-4">
          To confirm deletion, please solve this math problem:
        </p>
        <p className="text-xl font-bold text-center mb-4">
          {problem.question} = ?
        </p>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            const answer = (e.target as HTMLFormElement).answer.value;
            onConfirm(answer);
          }}
          className="space-y-4"
        >
          <input
            type="text"
            name="answer"
            required
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter your answer"
          />
          <div className="flex justify-end space-x-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
            >
              Verify & Delete
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};